import { QueryAreaAuthTree, QueryDictData, QueryUserAllList } from '@/request/cust-components';
import { renderChildren } from '@/utils/common';

export default {
    state: {
        userList: [],
        areaAuthTree: [],
        dictInfo: {}
    },
    mutations: {
        SET_USER_LIST(state, userList) {
            state.userList = userList;
        },
        SET_AREA_AUTH_TREE(state, areaAuthTree) {
            state.areaAuthTree = areaAuthTree;
        }
    },
    actions: {
        QUERY_COMPONENT_USER_ALL_LIST: async ({ commit }, payload) => {
            let res = await QueryUserAllList(payload);
            if (res.code == 200 && res.data) {
                commit('SET_USER_LIST', res.data);
            } else {
                commit('SET_USER_LIST', []);
            }
            return res;
        },

        QUERY_AREA_AUTH_TREE: async ({ commit }, payload) => {
            let res = await QueryAreaAuthTree(payload);
            if (res.code == 200 && res.data) {
                let list = renderChildren(res.data);
                commit('SET_AREA_AUTH_TREE', list);
            } else {
                commit('SET_AREA_AUTH_TREE', []);
            }
            return res;
        },

        QUERY_DICT_DATA: async ({ commit }, payload) => {
            let res = await QueryDictData(payload);
            if (res.code == 200 && res.data) {
                commit('SET_DICT_DATA', res.data);
            } else {
                commit('SET_DICT_DATA', []);
            }
            return res;
        }
    }
};
